import React from 'react';
import { object, string } from 'prop-types';

import CaseLabel from 'containers/CaseCave/CaseDetails/CaseLabels/CaseLabel';
import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const IndicatorPill = ({ title, color, fontColor, fontSize, width, height, style }) => (
    <CaseLabel
        title={title}
        color={color}
        fontColor={fontColor}
        fontSize={fontSize}
        style={{
            fontWeight: '500',
            fontFamily: 'Roboto',
            padding: '6px 12px',
            borderRadius: '50px',
            whiteSpace: 'nowrap',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
            width,
            height,
            ...style,
        }}
    />
);

IndicatorPill.propTypes = {
    title: string.isRequired,
    color: string,
    fontColor: string,
    fontSize: string,
    width: string,
    height: string,
    style: object,
};

IndicatorPill.defaultProps = {
    color: MIGRATED_COLORS.orange,
    fontColor: MIGRATED_COLORS.white,
    fontSize: '14px',
    width: '189px',
    height: '26px',
    style: {},
};

export default IndicatorPill;
